"use client";
import Link from "next/link";
import { Button, type ButtonProps } from "@mui/material";

type ButtonLinkProps = ButtonProps<typeof Link>;

export default function ButtonLink(props: ButtonLinkProps) {
    return <Button component={Link} {...props} />;
}
